export const getButtonCLassNames = (variant: string | null) => {
	switch (variant) {
		case 'Primary':
			return 'bg-primary-lightViolet text-white border-4 border-primary-lightViolet hover:bg-secondary-lemon hover:text-primary-lightViolet';
		case 'Secondary':
			return 'bg-transparent text-primary-lightViolet border-4 border-primary-lightViolet hover:text-white hover:bg-primary-darkViolet hover:border-primary-darkViolet';
		default:
			return 'bg-primary-lightViolet text-white border-4 border-primary-lightViolet hover:bg-secondary-lemon hover:text-primary-lightViolet';
	}
};
